module.exports = __webpack_public_path__ + "static/media/vis18.44d90924.jpeg";